import React from 'react';
import { Spinner } from 'src/design-system';

const SpinnerLoader: React.FC<{
  fullscreen?: boolean;
}> = ({ fullscreen = true }) => {
  return (
    <div className={`flex items-center justify-center ${fullscreen ? 'min-h-screen' : ''}`}>
      <Spinner size="lg" color="accent" />
    </div>
  );
};

export default SpinnerLoader;
